<template lang="pug">
	.campaign-streamings-selection
		.flex-row.space
			ListView.full-width(ref="listView", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns", initialView="cards", :hideViewsSelection="true")
				template(v-slot:card="{ data }")
					StreamingCard(:record="data")
						template(slot="actions")
							DxButton(:text="$tCaption('Select', '@actions')", icon="fas fa-check" type="succsess", @click="$emit('select', data)")
				.filters-panel.flex-col.wrap.space(slot="left", v-if="!disableFilters")
					.flex-row.space.align-center
						Dropdown(:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="$Data.getExternalNetworks",
							:columns="[{ dataField: 'Name', caption: $tCaption('Network') }]",
							displayExpr="Name",
							valueExpr="Oid",
							:placeholder="$tCaption('Network')",
							:selectedItems="filters.network && filters.network.Oid",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:searchVisible="true",
							:multiple="false",
							@select-data="item => filters.network = item")
					.flex-row.space.align-center
						DxSelectBox.flex-1(:data-source="adPlacements", :value.sync="filters.adPlacement", display-expr="name", value-expr="id", :placeholder="$tCaption('Placement')")
						.clickable(v-if="filters.adPlacement", @click="filters.adPlacement = null")
							i.fas.fa-times-circle
					.flex-row.space.align-center
						DxSelectBox.flex-1(:data-source="ratingMethods", :value.sync="filters.ratingMethod", display-expr="name", value-expr="id", :placeholder="$tCaption('Rating method')")
						.clickable(v-if="filters.ratingMethod", @click="filters.ratingMethod = null")
							i.fas.fa-times-circle
					RangeFilter(ref="duration", :title="$tCaption('Duration (sec.)')", width="200px", v-model="filters.duration")
					RangeFilter(ref="price", :title="$tCaption('Price')", width="200px", v-model="filters.RatePrice")
					DxButton(text="Apply filters", type="default", @click="$refs.listView.loadData({ clear: true })")
				template(v-slot:name-cell-template="{ data }")
					.flex-row.table-info.space.align-center
						.img-holder(:style="{ backgroundImage: `url('${data.ImageUrl}')` }")
						.flex-col.space
							b.title.wrap {{data.name}}
				template(v-slot:add-cell-template="{ data }")
					DxButton(:text="$tCaption('Select', '@actions')", icon="fas fa-check" type="succsess", @click="$emit('select')")
</template>

<script>
	import Data from 'app-core/Data';
	import ListView from 'app-core/ListView.vue';
	import RangeFilter from 'app-core/RangeFilter.vue';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import { RATING_METHODS, AD_RUN_TYPES } from 'app-core/constants';
	import Dropdown from 'app-core/Dropdown.vue';
	import StreamingCard from './StreamingCard.vue';

	export default {
		translationCategory: 'proposal.StreamingsSelection',
		name: 'streamings-selection',
		components: {ListView, RangeFilter, DxButton, DxSelectBox, DxDateBox, DxNumberBox, Dropdown, StreamingCard},
		mixins: [Data.mixin],
		props: ['dapCategories', 'info', 'disableFilters'],
		data() {
			return {
				columns: [
					{
						dataField: 'name',
						caption: () => this.$tCaption('Streaming'),
						cellTemplate: 'name-cell-template'
					},
					{ dataField: 'adPlacement', caption: () => this.$tCaption('Placement') },
					{ dataField: 'startTime', caption: () => this.$tCaption('Start'),  dataType: 'date', format: 'shortDateShortTime' },
					{ dataField: 'price', caption: () => this.$tCaption('Price'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 } },
					{ dataField: 'agreedPrice', caption: () => this.$tCaption('Agreed price'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 } },
					{ dataField: 'impressions', caption: () => this.$tCaption('Impressions'),  dataType: 'number', format: 'fixedPoint' },
					{ dataField: 'cpm', caption: () => this.$tCaption('CPM'),  dataType: 'number', format: '#0.##' },					
					{ dataField: 'name', cellTemplate: 'add-cell-template', caption: '', width: 80 },
					{ caption: '', width: 0 }
				],
				filters: {
					network: null,
					adPlacement: null,
					ratingMethod: null,
					duration: null,
					price: null
				},
				adPlacements: AD_RUN_TYPES.toLocale('name', this),
				ratingMethods: RATING_METHODS.toLocale('name', this)
			};
		},
		computed: {
			stationIdsCondition() {
				const stationIds = this.info?.campaign?.Stations?.map(f => f?.Oid)?.join(',');
				return stationIds ? `&stationIds=${stationIds}` : '';
			}
		},
		watch: {
			dapCategories() {
				this.$refs.listView.reload({ clear: true });
			}
		},
		mounted() {
			if (__DEBUG__)
				window.streamingsSelection = this;
		},
		methods: {
			getSeconds(ms) {
				return parseInt(ms/1000);
			},
			getRatingMethod(id) {
				const item = this.ratingMethods.filter(f => f.id === id)[0];
				return item && item.name;
			},
			getAdRunType(id) {
				const item = this.adPlacements.filter(f => f.id === id)[0];
				return item && item.name;
			},
			loadData(pageIndex, size) {
				var params = {
					NetworkId: this.filters.network?.Oid || null,
					MinDuration: (this.filters.duration || [])[0] * 1000 || null,
					MaxDuration: (this.filters.duration || [])[1] * 1000 || null,
					minRate: (this.filters.price || [])[0] || null,
					maxRate: (this.filters.price || [])[1] || null,
					RatingMethod: this.filters.ratingMethod,
					DapCategories: this.dapCategories
				};

				if (this.filters.adPlacement)
					params.AdRunType = this.filters.adPlacement;

				if (this.filters.ratingMethod)
					params.RatingMethod = this.filters.ratingMethod;

				params['page'] = pageIndex + 1;

				this.hasStreamings = false;
				return this.$Data.getExternalApi('Streaming/GetStreamings', 
					`${Object.keys(params).map(f => `${f}=${params[f]}`).filter(f => !f.endsWith('=null')).join('&')}${this.stationIdsCondition}&needFilterByUser=${this.$auth.proposalSettings().onlyMyStreamings}`, size
				).then(r => {
					if (__DEBUG__)
						console.info('Streamings loaded', { r, params });
					r.Results.map(f => {
						//CPM
						if (f.RatingMethod === 4) {
							f.AgreedPrice = ((f.Reach / 1000) * f.RatePrice) || null;
						} else {
							f.AgreedPrice = f.RatePrice;
						}
					});
					return r;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.campaign-streamings-selection {
		@import "main/themes/generated/variables.base.scss";

		.table-info {
			.img-holder {
				width: 80px;
				height: 80px;
				min-width: 80px;

				background-size: contain;
				background-position: center;
				border-radius: 4px;
				background-repeat: no-repeat;
			}

			.dto-red {
				padding: 4px;
				background: #e45656;
				text-align: center;
				color: #ffff;
				border-radius: 10px;
			}
		}

		.filters-panel {
			padding: 20px;
			flex-basis: 300px;
			background: #fff;
			border-radius: 4px;

			> *:not(:first-child) {
				margin-top: 20px;
			}
		}

		.streaming-card {
			-webkit-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			-moz-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);

			&:hover {
				transform: scale(1.025) translateY(-8px);

				.dates {
					background: $base-accent;
					color: $base-bg;

					.grey {
						color: $base-bg-transparent;
					}
				}
			}

			&.selected {
				.dates {
					background: #9becda;
					color: #43b198;
					border-bottom: 2px solid #9becda;

					.grey {
						color: #43b19880;
					}
				}
			}
		}
	}
</style>
